// Keep JSON serialization and synchronous storage off the typing hot path.
export function createProcessDraftWriter(storage, delay = 300) {
  let pending = null;
  let timer = null;
  const cancel = () => {
    clearTimeout(timer);
    timer = null;
    pending = null;
  };
  const flush = () => {
    const entry = pending;
    cancel();
    if (entry) {
      try { storage.setItem(entry.key, JSON.stringify(entry.values)); } catch { /* Draft storage is best effort. */ }
    }
  };
  return {
    schedule(key, values) {
      if (pending && pending.key !== key) flush();
      clearTimeout(timer);
      pending = { key, values };
      timer = setTimeout(flush, delay);
    },
    flush,
    cancel,
  };
}
